/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CreateMarkupRequest extends models.MarkupDetails {
    getFixupPrototypeFunction() { return CreateMarkupRequest.fixupPrototype; }

    static newInstance(model: Partial<CreateMarkupRequest>): CreateMarkupRequest {
        let obj = Object.assign(new CreateMarkupRequest(), model);
        CreateMarkupRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CreateMarkupRequest>): CreateMarkupRequest {
        if (!model) return null;
        return CreateMarkupRequest.newInstance(<CreateMarkupRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CreateMarkupRequest) {
        if (!obj) return;

        models.CreateMarkupRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CreateMarkupRequest): boolean {
        if (models.MarkupDetails.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CreateMarkupRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
